// extracted by mini-css-extract-plugin
export var table = "_ya-0";